import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep9 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Medal_Prize_Reward.5",
	"data-name": "Medal, Prize, Reward.5",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_14046",
		"data-name": "Group 14046",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11771",
				"data-name": "Path 11771",
				d: "M12,22V21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11772",
				"data-name": "Path 11772",
				d: "M5.69,20.31l.62-.62",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11773",
				"data-name": "Path 11773",
				d: "M19.5,14h1",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11774",
				"data-name": "Path 11774",
				d: "M3.5,14h1",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11775",
				"data-name": "Path 11775",
				d: "M17.69,19.69l.62.62",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11776",
				"data-name": "Path 11776",
				d: "M14.946,11.054a4.167,4.167,0,1,1-5.893,0,4.167,4.167,0,0,1,5.893,0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11777",
				"data-name": "Path 11777",
				d: "M16.43,6H7.57",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11778",
				"data-name": "Path 11778",
				d: "M15.676,12.078,19.492,7.8A2,2,0,0,0,20,6.469V4a2.006,2.006,0,0,0-2-2H6A2,2,0,0,0,4,4V6.469A2,2,0,0,0,4.508,7.8l3.816,4.278",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11779",
				"data-name": "Path 11779",
				d: "M4.57,2.63l6.51,7.31",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11780",
				"data-name": "Path 11780",
				d: "M19.43,2.63,12.92,9.94",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11781",
		"data-name": "Path 11781",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgStep9;
